/* @flow */

import SupportSentErrorNotification from 'src/shared/app/support/component/SupportSentErrorNotification';
import SupportSentNotification from 'src/shared/app/support/component/SupportSentNotification';
import {
  notificationSuccessLevel,
  notificationErrorLevel,
  notificationTopType,
} from 'src/shared/app/notification/constant/notificationConstants';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

export function convertSupportSentToNotification(): Notification {
  return {
    id: 'support-sent',
    level: notificationSuccessLevel,
    type: notificationTopType,
    componentClass: SupportSentNotification,
  };
}

export function convertSupportSentErrorToNotification(): Notification {
  return {
    id: 'support-sent-error',
    level: notificationErrorLevel,
    type: notificationTopType,
    componentClass: SupportSentErrorNotification,
  };
}
